import { CoreClientApiTags } from '@cp/shared/api/core';

export { CoreClientApiTags };

export const coreClientApiTagTypes = Object.values(CoreClientApiTags);
